import { createBrowserHistory } from 'history';

// We're pulling this away from the Router component so
// that we can access it throughout the rest of the app
// (e.g. in Redux sagas)

export default createBrowserHistory();



// WEBPACK FOOTER //
// ./src/utils/history.js